module.exports = __webpack_public_path__ + "static/media/LightBulbGrey.7c62d551.svg";